import type { SocialLink } from '@/hooks/useSocialLinks';

const stripNonDigits = (value: string) => value.replace(/[^0-9+]/g, '');

export const formatSocialHref = (link: SocialLink): string => {
  const platform = link.platform.toUpperCase();
  const raw = (link.url || '').trim();

  if (!raw) {
    return '#';
  }

  if (platform === 'EMAIL') {
    return raw.startsWith('mailto:') ? raw : `mailto:${raw}`;
  }

  if (platform === 'PHONE') {
    const normalized = raw.startsWith('tel:') ? raw : `tel:${stripNonDigits(raw) || raw}`;
    return normalized;
  }

  if (platform === 'WHATSAPP') {
    if (/^https?:\/\//i.test(raw)) {
      return raw;
    }
    const digits = stripNonDigits(raw);
    return digits ? `https://wa.me/${digits.replace(/^\+/, '')}` : raw;
  }

  // Handle Messenger platform - convert Facebook page to Messenger format
  if (platform === 'MESSENGER') {
    if (/^https?:\/\/(www\.)?facebook\.com\/([^/?]+)/i.test(raw)) {
      const pageName = raw.match(/^https?:\/\/(www\.)?facebook\.com\/([^/?]+)/i)?.[2];
      return pageName ? `https://m.me/${pageName}` : raw;
    }
    if (/^https?:\/\/m\.me\//i.test(raw)) {
      return raw;
    }
    // If it's just a page name, assume it's a Facebook page
    if (!/^https?:\/\//i.test(raw)) {
      return `https://m.me/${raw}`;
    }
    return raw;
  }

  if (!/^https?:\/\//i.test(raw) && !raw.startsWith('mailto:') && !raw.startsWith('tel:')) {
    return `https://${raw}`;
  }

  return raw;
};

export const formatSocialDisplayText = (link: SocialLink, fallback: string): string => {
  if (link.displayText && link.displayText.trim().length > 0) {
    return link.displayText.trim();
  }
  if (link.url && link.url.trim().length > 0) {
    return link.url.trim();
  }
  return fallback;
};
